import { render } from "./VerifyRegistrationPage.vue?vue&type=template&id=5f49014e&scoped=true&ts=true"
import script from "./VerifyRegistrationPage.vue?vue&type=script&lang=ts"
export * from "./VerifyRegistrationPage.vue?vue&type=script&lang=ts"

import "./VerifyRegistrationPage.vue?vue&type=style&index=0&id=5f49014e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f49014e"]])

export default __exports__